import { INJECTABLE_SYMBOL } from './Injectable.js';
import { getResolutionStrategy } from './serviceResolve.js';
/**
 * Symbol used to identify service instances.
 * @internal
 */
const SERVICE_SYMBOL = Symbol('service');
/**
 * Creates a new service with the specified options.
 *
 * @template T - The type that the service will resolve to
 * @template TExtend - The extended type that the service will resolve to (for inheritance)
 * @template TDeps - The type of the service's dependencies
 * @param options - Configuration options for the service
 * @returns A new service instance
 * @__NO_SIDE_EFFECTS__
 */
export function defineService(options) {
    const name = options.name ?? options.implements?.name ?? 'UnnamedService';
    const resolution = getResolutionStrategy(options.resolution ?? 'singleton');
    const service = {
        [INJECTABLE_SYMBOL]: SERVICE_SYMBOL,
        name,
        implements: options.implements,
        scope: options.scope,
        deps: options.deps ?? {},
        resolve: (container, caller) => resolution(service, container, caller),
        create: options.setup,
    };
    return service;
}
/**
 * Type guard to check if a value is a Service instance.
 * @param value - The value to check
 * @returns True if the value is a Service, false otherwise
 */
export function isService(value) {
    return value != null && value[INJECTABLE_SYMBOL] === SERVICE_SYMBOL;
}
//# sourceMappingURL=Service.js.map